<!-- LOGIN FORM  -->
<!-- [style.--color-main-1] registra el color dinámico del cliente como CSS custom property:
     a diferencia de [ngStyle] (que solo puede fijar el estado base de UN elemento), esto lo
     deja disponible con var(--color-main-1) para cualquier selector del .scss de acá abajo,
     incluidos :hover/:focus/lo que haga falta. -->
<div
  class="white"
  *ngIf="activeform.login"
  [style.--color-main-1]="getClientsSettingAppAuth?.clients_setting_global?.color_main_1"
>
  <h3 *ngIf="!load && !twoFactorRequired && variant === 'classic'" class="text-left title pb-1 text-uppercase">ENTRAR</h3>
  <h3 *ngIf="!load && twoFactorRequired" class="text-left title pb-1 text-uppercase">VERIFICACIÓN EN DOS PASOS</h3>
  <!--ACA-->
  <!-- <h3 class="text-left title pb-1 text-uppercase"> LOGIN</h3> -->

  <form
    *ngIf="!twoFactorRequired"
    [formGroup]="loginForm"
    (ngSubmit)="onLogin(); loginForm.reset()"
    novalidate
  >

  <ng-container *ngIf="variant === 'classic'">
    <div class="container">
        <div class="row" *ngIf="!load">
        <div class="col-12 col-md-4 p-0">
          <input
            id="email"
            class="form-control"
            placeholder="e.g: calrissian@domain.com"
            type="email"
            formControlName="email"
          />
          <!-- ERRORS -->
          <div
            *ngIf="
              loginForm.controls.email.invalid &&
              (loginForm.controls.email.dirty ||
                loginForm.controls.email.touched)
            "
          >
            <span
              class="s-sm booking"
              *ngIf="loginForm.controls.email.errors.required"
            >
              <!-- Por favor, inserte un correo electrónico. -->
              Por favor, introduzca un email.
            </span>
            <span
              class="s-sm booking"
              *ngIf="loginForm.controls.email.errors.pattern"
            >
              <!-- Por favor, inserte un correo electrónico válido. -->
              Por favor, introduzca un email válido.
            </span>
          </div>
        </div>
        <div class="col-12 col-md-4 pl-2">
          <!-- <div class="password-input" style="position: relative;"> -->
          <input
            class="form-control"
            placeholder="e.g: **********"
            [type]="showPassword ? 'text' : 'password'"
            name="password"
            id="password"
            formControlName="password"
            required
          />
          <button
            title="eye"
            type="button"
            class="password-toggle-btn"
            (click)="togglePasswordVisibility()"
            style="
              position: absolute;
              top: 14%;
              left: 83%;
              border: 0px;
              background: transparent;
            "
          >
            <i
              class="fa"
              [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"
            ></i>
          </button>
          <!-- </div> -->
          <!-- <input id="password" class="form-control" placeholder="e.g: **********" type="password"
	            formControlName="password"> -->
          <!-- ERRORS -->
          <div
            *ngIf="
              loginForm.controls.password.invalid &&
              (loginForm.controls.password.dirty ||
                loginForm.controls.password.touched)
            "
          >
            <span
              class="s-sm booking"
              *ngIf="loginForm.controls.password.errors.required"
            >
              <!-- Por favor, inserte una contraseña. -->
              Por favor, inserte una contraseña.
            </span>
            <span
              class="s-sm booking"
              *ngIf="loginForm.controls.password.errors.minlength"
            >
              <!-- La contraseña debe tener al menos 6 caracteres. -->
              La contraseña debe tener al menos 6 carácteres
            </span>
          </div>
        </div>
        <div class="col-12 col-md-4 text-right">
          <input
            class="btn-button s-l rounded-pill"
            type="submit"
            value="ENTRAR"
            [disabled]="!loginForm.valid"
            [ngStyle]="{
              'background-color':
                getClientsSettingAppAuth?.clients_setting_global?.color_main_1
            }"
            style="margin-top: -8px"
          />
          <!--aca-->
        </div>
      </div>
      <div class="row" *ngIf="!load && turnstileEnabled">
        <div class="col-12 d-flex justify-content-center mt-2">
          <app-turnstile
            [siteKey]="turnstileSiteKey"
            action="login"
            [invisibleUntilSubmit]="true"
            (verified)="onTurnstileVerified($event)"
            (expired)="onTurnstileExpired()"
            (errored)="onTurnstileError()">
          </app-turnstile>
        </div>
      </div>
    </div>

    <div *ngIf="twoFactorRequired" class="container">
      <div class="row" *ngIf="!load">
        <div class="col-12 col-md-6 p-0">
          <input
            #twoFactorInput
            class="form-control"
            placeholder="123456"
            maxlength="6"
            inputmode="numeric"
            pattern="[0-9]*"
            [value]="twoFactorCode"
            (input)="twoFactorCode = twoFactorInput.value"
            (keyup.enter)="onVerifyTwoFactor()"
          />
          <span class="s-sm booking" *ngIf="twoFactorError">
            Código inválido, intentá de nuevo.
          </span>
        </div>
        <div class="col-12 col-md-6 text-right">
          <input
            class="btn-button s-l rounded-pill"
            type="button"
            value="VERIFICAR"
            [disabled]="twoFactorCode.length !== 6"
            (click)="onVerifyTwoFactor()"
            [ngStyle]="{
              'background-color':
                getClientsSettingAppAuth?.clients_setting_global?.color_main_1
            }"
            style="margin-top: -8px"
          />
        </div>
      </div>
      <div *ngIf="load">
        <div
          class="d-flex justify-content-center align-items-center"
          style="margin-top: 5%"
        >
          <div
            class="spinner-border spinner-border-sm text-white mr-2"
            role="status"
          ></div>
          <p class="text-white mb-0 font-weight-bold">CARGANDO...</p>
        </div>
      </div>
      <p *ngIf="!load" class="s-sm pt-2" align="left">
        <span
          class="link-booking f-bold f-underline pr-1"
          (click)="cancelTwoFactor()"
          >&lt; Volver</span
        >
      </p>
    </div>

    <p *ngIf="!load && !twoFactorRequired" class="s-sm pt-2" align="left">
      <span
        class="link-booking f-bold f-underline pr-1"
        (click)="callRecoverForm('user')"
        >¿Olvidaste tu usuario?</span
      >
      <span style="font-size: 14px; cursor: default"> | </span>
      <span
        class="link-booking f-bold f-underline pr-4 pl-1"
        (click)="callRecoverForm('password')"
        >¿Olvidaste tu contraseña?</span
      >
      <!--ACA-->
      <!-- <span class="link-booking f-bold f-underline pr-4" (click)="callRecoverForm();">Did you forget your password?</span> -->
      <!-- <span class="link-booking" style="font-size: 19px;"> | </span> <a pageScroll data-toggle="modal" data-target="#modalJoinus"
          class="link-booking f-bold f-underline white pl-4"> Do you want to register? </a> -->
      <span style="font-size: 19px; cursor: none"> | </span>
      <a
        pageScroll
        data-toggle="modal"
        data-target="#modalJoinus"
        class="link-booking f-bold f-underline white pl-4"
      >
        ¿Quieres registrarte?
      </a>
      <!--aca-->
    </p>
  </ng-container>

  <ng-container *ngIf="variant === 'animated'">
    <div *ngIf="!load" class="container-variant-animated">

      <!-- EMAIL/CREDENCIALES -->
      <div class="container-input-animated">
        <input
                type="email"
                placeholder="Email"
                class="input-variant-animated"
                formControlName="email"
                required
        >
        <div class="container-error-input-variant-animated"
          >
          <ng-container *ngIf="
                                loginForm.controls.email.invalid &&
                                (loginForm.controls.email.dirty ||
                                loginForm.controls.email.touched)
                              "
          >
             <span
              class="s-sm booking"
              *ngIf="loginForm.controls.email.errors.required"
            >
              Por favor, introduzca un email.
            </span>
            <span
              class="s-sm booking"
              *ngIf="loginForm.controls.email.errors.pattern"
            >
              Por favor, introduzca un email válido.
            </span>
          </ng-container>

          </div>
      </div>
      <div class="container-input-animated">
        <input
               [type]="showPassword ? 'text' : 'password'"
               class="input-variant-animated"
               placeholder="Contraseña"
               name="password"
               id="password"
               formControlName="password"
               required
        >
        <button
              title="eye"
              type="button"
              class="password-toggle-btn-animated"
              (click)="togglePasswordVisibility()"
            >
              <i
                class="fa"
                [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"
              ></i>
          </button>
      </div>

      <!-- SEGUNDO PASO: código del authenticator (TOTP / Google Authenticator) -->
      <div *ngIf="twoFactorRequired" class="container">
        <div class="row" *ngIf="!load">
          <div class="col-12 col-md-6 p-0">
            <input
              #twoFactorInput
              class="form-control"
              placeholder="123456"
              maxlength="6"
              inputmode="numeric"
              pattern="[0-9]*"
              [value]="twoFactorCode"
              (input)="twoFactorCode = twoFactorInput.value"
              (keyup.enter)="onVerifyTwoFactor()"
            />
            <span class="s-sm booking" *ngIf="twoFactorError">
              Código inválido, intentá de nuevo.
            </span>
          </div>
          <div class="col-12 col-md-6 text-right">
            <input
              class="btn-button s-l rounded-pill"
              type="button"
              value="VERIFICAR"
              [disabled]="twoFactorCode.length !== 6"
              (click)="onVerifyTwoFactor()"
              [ngStyle]="{
                'background-color':
                  getClientsSettingAppAuth?.clients_setting_global?.color_main_1
              }"
              style="margin-top: -8px"
            />
          </div>
        </div>
        <div *ngIf="load">
          <div
            class="d-flex justify-content-center align-items-center"
            style="margin-top: 5%"
          >
            <div
              class="spinner-border spinner-border-sm text-white mr-2"
              role="status"
            ></div>
            <p class="text-white mb-0 font-weight-bold">CARGANDO...</p>
          </div>
        </div>
        <p *ngIf="!load" class="s-sm pt-2" align="left">
          <span
            class="link-booking f-bold f-underline pr-1"
            (click)="cancelTwoFactor()"
            >&lt; Volver</span
          >
        </p>
      </div>

      <!--  RECUPERAR USUARIO / RECUPERAR CONTRASEÑA / REGISTRARSE -->
      <ng-container *ngIf="!load && !twoFactorRequired">
        <div class="container-link-user-action-login-animated">
            <a class="link-user-action-login-animated" (click)="callRecoverForm('user')">¿Olvidaste tu usuario?</a>
            <a class="link-user-action-login-animated" (click)="callRecoverForm('password')">¿Olvidaste tu contraseña?</a>
            <a class="link-user-action-login-animated"  pageScroll
                      data-toggle="modal"
                      data-target="#modalJoinus">¿Quieres registrarte?</a>
        </div>
      </ng-container>

      <button
              type="submit"
              class="btn-login-animated"
      >
          <p>
             ENTRAR
          </p>
          <i class="bi bi-arrow-right"></i>
      </button>

       <div class="row" *ngIf="!load && turnstileEnabled">
        <div class="col-12 d-flex justify-content-center mt-2">
          <app-turnstile
            [siteKey]="turnstileSiteKey"
            action="login"
            [invisibleUntilSubmit]="true"
            (verified)="onTurnstileVerified($event)"
            (expired)="onTurnstileExpired()"
            (errored)="onTurnstileError()">
          </app-turnstile>
        </div>
      </div>

    </div>


    <!-- <div class="container">
        <div class="row" *ngIf="!load">

        <div class="col-12 col-md-4 text-right">
          <input
            class="btn-button s-l rounded-pill"
            type="submit"
            value="ENTRAR"
            [disabled]="!loginForm.valid"
            [ngStyle]="{
              'background-color':
                getClientsSettingAppAuth?.clients_setting_global?.color_main_1
            }"
            style="margin-top: -8px"
          />
        </div>
      </div>
      <div class="row" *ngIf="!load && turnstileEnabled">
        <div class="col-12 d-flex justify-content-center mt-2">
          <app-turnstile
            [siteKey]="turnstileSiteKey"
            action="login"
            [invisibleUntilSubmit]="true"
            (verified)="onTurnstileVerified($event)"
            (expired)="onTurnstileExpired()"
            (errored)="onTurnstileError()">
          </app-turnstile>
        </div>
      </div>
    </div> -->


  </ng-container>



    <div *ngIf="load">
      <div
        class="d-flex justify-content-center align-items-center"
        style="margin-top: 5%"
      >
        <div
          class="spinner-border spinner-border-sm text-white mr-2"
          role="status"
        ></div>
        <!-- <p class="s-m"> Cargando... </p> -->
        <p class="text-white mb-0 font-weight-bold">CARGANDO...</p>
      </div>
    </div>

  </form>

</div>

<!-- RECOVER PASSWORD FORM  -->

<div *ngIf="!activeform.login" class="white container-form-recovery" style="min-height: 95px">
  <h3
    *ngIf="!load && loadingResetPass"
    class="hero-login-title-others-action mt-2"
  >
    ¿Olvidaste tu {{ actionRecover }}?
  </h3>
  <resetpass (finished)="callLoginForm()"
              [clientSetting]="getClientsSettingAppAuth"
              (loadResetPass)="loadResetPass()">
  </resetpass>
  <div class="d-flex mt-5 align-items-center" style="gap: 4px">
      <i class="bi bi-arrow-left" style="font-size: .6em"></i>
         <a class="link-user-action-login-animated "
        (click)="callLoginForm()"
        *ngIf="!load && loadingResetPass"
      >
        &nbsp;Atras
      </a>
  </div>

</div>

<ng-template #ModalSelectAgency>
  <usb-select-agency-modal
    [modalRoomRef]="modalRef"
    [arrayAgencyUser]="agencysUser"
    [_data]="data"
  >
  </usb-select-agency-modal>
</ng-template>


